import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import CAxios from "../utils/CAxios";

//GET school profile details
export const getSchoolProfileDetails = createAsyncThunk<
  AxiosResponse<any, any>
>("school/GetSchoolProfileDetails", async () => {
  try {
    let response = await CAxios.get(`profile/details`);
    return response?.data;
  } catch (error) {
    throw error;
  }
});
//GET Observations
export const getSchoolObservations = createAsyncThunk<AxiosResponse<any, any>>(
  "school/GetSchoolObservations",
  async () => {
    try {
      let response = await CAxios.get(`beneficiary/observations`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
// add note
export const AddNoteToStudent = createAsyncThunk<AxiosResponse<any, any>, any>(
  "school/observations",
  async (data) => {
    try {
      const response = await CAxios.post(`beneficiary/observations`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
